import { Button, FormControl, FormHelperText, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from "@mui/material";
import { useCadastrarEditarProdutoContext } from "../../contexts/CadastrarEditarProdutoContext";
import { ConsultaContainer } from "../ConsultarIndustrializadoContainer/styles";
import { ButtonsContainer, Formulario, ImagemContainer } from "./styles";
import { CardUploadImagem } from "../../../core/components/CardUploadImagem";
import { useEffect, useState } from "react";
import { IImagemProduto } from "../../interfaces/IImagemProduto";

interface PrecificacaoIndustrializadoContainerProps {

}

export const PrecificacaoIndustrializadoContainer = ({ }: PrecificacaoIndustrializadoContainerProps) => {
    const {
        preco,
        setPreco,
        handleVoltar,
        resetIndustrializado,
        produto,
        formErrors,
        handleProximo,
        precoSemDesconto,
        setPrecoSemDesconto,
        descricao,
        setDescricao,
        imagens,
        handleExcluirImagem,
        handleUploadImagem
    } = useCadastrarEditarProdutoContext();

    const [imagem, setImagem] = useState<undefined | File | IImagemProduto>(undefined);

    useEffect(() => {
        if (imagens?.length) {
            setImagem(imagens[0]);
        } else {
            setImagem(undefined);
        }
    }, [imagens])

    const voltar = () => {
        resetIndustrializado();
        handleVoltar();
    }

    return (
        <ConsultaContainer>
            <Formulario>
                <Typography
                    variant="h6"
                    sx={{ width: "100%", marginBottom: "1rem" }}
                >
                    Detalhes
                </Typography>
                <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                    <TextField
                        label="Nome"
                        onChange={(e) => setDescricao(e.target.value)}
                        value={descricao}
                        error={!!formErrors?.descricao}
                        helperText={<>{formErrors?.descricao}</>}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Ex: Coca Cola, Guaraná, etc..."
                    />
                </FormControl>
                <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                    <InputLabel error={!!formErrors?.preco} htmlFor="preco-industrializado">Preço</InputLabel>
                    <OutlinedInput
                        id="preco-industrializado"
                        startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                        label="Preço"
                        value={preco}
                        onChange={(e) => setPreco(e.target.value)}
                        error={!!formErrors?.preco}
                    />
                    {!!formErrors?.preco && (
                        <FormHelperText error={true}>{formErrors.preco}</FormHelperText>
                    )}
                </FormControl>
                <FormControl sx={{ marginTop: "1rem" }} fullWidth>
                    <InputLabel error={!!formErrors?.precoSemDesconto} htmlFor="preco-industrializado-sem-desconto">Preço sem desconto</InputLabel>
                    <OutlinedInput
                        id="preco-industrializado-sem-desconto"
                        startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                        label="Preço sem desconto"
                        value={precoSemDesconto}
                        onChange={(e) => setPrecoSemDesconto(e.target.value)}
                        error={!!formErrors?.precoSemDesconto}
                    />
                    {!!formErrors?.precoSemDesconto && (
                        <FormHelperText error={true}>{formErrors.precoSemDesconto}</FormHelperText>
                    )}
                </FormControl>
                <ImagemContainer>
                    <CardUploadImagem
                        titulo="Imagem"
                        descricao={
                            imagem
                                ? (imagem instanceof File ? imagem?.name : (imagem?.nomeOriginal ?? imagem?.nome))
                                : "Faça o upload"
                        }
                        url={imagem instanceof File ? URL.createObjectURL(imagem) : imagem?.url}
                        excluir={handleExcluirImagem}
                        upload={handleUploadImagem}
                    />
                </ImagemContainer>
                <ButtonsContainer>
                    <Button variant="outlined" onClick={voltar} disabled={produto ? true : false}>
                        Voltar
                    </Button>
                    <Button variant="contained" onClick={handleProximo}>
                        Próximo
                    </Button>
                </ButtonsContainer>
            </Formulario>
        </ConsultaContainer>
    );
}